import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { LoadButtonHeaderTable } from '../../../components/sharedViews/loadActionsHeader/LoadButtonHeaderTable';
import LoadingOverlay from '../../../components/others/LoadingOverlay';
import { MapComponent } from '../components/Map';

export const LayoutMaps = () => {
    const location = useLocation();
    const [configuration, setConfiguration] = useState({});
    const [filters, setfilter] = useState({});
    const [buttons, setButtons] = useState([]);
    const [loading, setLoading] = useState(true);

    const parseConfiguration = (configuration) => {
        if (!configuration) return { buttons: [] };
        try {
            const parsed = JSON.parse(configuration);
            return { buttons: parsed?.button || [] };
        } catch (e) {
            return { buttons: [] };
        }
    };

    useEffect(() => {
        const configRaw = location.state?.configuration;

        if (configRaw) {
            try {
                setConfiguration(JSON.parse(configRaw));
                const { buttons } = parseConfiguration(configRaw);
                setButtons(buttons);
            } catch (e) {
                console.error("Error parsing configuration JSON:", e);
                setConfiguration({});
            }
        }

        setLoading(false);
    }, []);


    const setfil = (obj) => setfilter(prev => ({ ...prev, ...obj }));

    return (
        <Box sx={{ width: '100%' }}>

            <Box sx={{ mb: 2, pt: 2, pl: 2, pr: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Breadcrumbs separator="›">
                        <Link underline='hover' color='text.main'>
                            <Typography sx={{ fontWeight: 'bold' }}>
                                {configuration?.title || 'Mapa'}
                            </Typography>
                        </Link>
                    </Breadcrumbs>

                    <Grid>
                        <LoadButtonHeaderTable
                            buttons={buttons}
                            id_user_action={''}
                            DocManager={null}
                            columns={[]}
                            handleChange={setfil}
                        />
                    </Grid>
                </Box>
            </Box>

            <MapComponent config={configuration} filters={filters} />
            <LoadingOverlay isOpen={loading} />
        </Box>
    );
};
